// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"3041cb33","145":"6fb673d8","555":"a581c624","716":"8d901bcc","748":"ede50406"}[chunkId] + ".chunk.js";
};